module.exports = __webpack_public_path__ + "static/media/ImporterFeatureIcon1.34447cc7.svg";